<template>
  <div class="container">
    <div class="handle-wrapper">
      <Input
        v-model="searchText"
        search
        placeholder="搜索复配中心公司..."
        @on-change="searchSacCompany"
        style="width: 250px; margin-right: auto"
      >
        <Button
          slot="append"
          icon="ios-search"
          @click="searchSacCompany"
        ></Button>
      </Input>
      <span>共{{ totalRows }}条</span>
      <Page
        :total="totalRows"
        :page-size="15"
        @on-change="loadSacCompany"
        show-total
        simple
        style="margin-right: 24px"
      />
      <Button type="primary" @click="$refs.EditSACCompanyDrawer.openDrawer()"
        >新增SAC公司</Button
      >
    </div>
    <div class="table-wrapper" ref="tableWrapper">
      <Table
        :loading="tableLoading"
        :columns="columns"
        :data="tableData"
        :height="tableHeight"
      />
    </div>
    <EditSACCompanyDrawer ref="EditSACCompanyDrawer" />
  </div>
</template>

<script>
import EditSACCompanyDrawer from "./EditSACCompanyDrawer.vue";
import { mapState, mapActions, mapGetters } from "vuex";

export default {
  name: "SacCompany",
  components: { EditSACCompanyDrawer },
  props: {},
  data() {
    return {
      page: 0,
      tableHeight: 300,
      searchText: "",
      tableLoading: false,
      columns: [
        {
          title: "名字",
          key: "name",
          // width: 130,
          render: (h, params) => {
            return h("div", [
              h(
                "h4",
                {
                  props: {
                    type: "text",
                    size: "small",
                  },
                  style: {
                    color: "#42b983",
                    cursor: "pointer",
                  },
                  on: {
                    click: () => {
                      this.$refs.EditSACCompanyDrawer.openDrawer(params.row);
                    },
                  },
                },
                params.row.name
              ),
            ]);
          },
        },
      ],
    };
  },
  computed: {
    ...mapState({
      tableData: (state) => state.sacCompany.sacCompanys,
      totalRows: (state) => state.sacCompany.totalCounts,
    }),
  },
  methods: {
    ...mapActions({
      getSacCompanys: "sacCompany/getSacCompanysAction",
    }),
    async loadSacCompany(page) {
      if (page) this.page = page - 1;
      let api = { skip: this.page * 15, limit: 15 };
      if (this.searchText) api.searchText = this.searchText;

      try {
        this.tableLoading = true;
        await this.getSacCompanys({ api });
        this.tableLoading = false;
      } catch (error) {
        this.$Message.error(`加载失败: ${error}`);
        this.tableLoading = false;
      }
    },
    searchSacCompany() {
      this.page = 0;
      this.loadSacCompany();
    },
  },
  created() {
    this.loadSacCompany();
  },
  mounted() {
    this.tableHeight = this.$refs.tableWrapper.offsetHeight;
    window.onresize = () => {
      this.tableHeight = this.$refs.tableWrapper.offsetHeight;
    };
  },
  destroyed() {
    window.onresize = null;
  },
};
</script>

<style scoped lang="stylus">
.handle-wrapper
  width 100%
  height 48px
  display flex
  align-items center
  justify-content flex-end

.table-wrapper
  width 100%
  height calc(100% - 48px)
</style>
